import { useQuery } from '@tanstack/react-query';

import { Skeleton } from '@nesso/ui/primitives/skeleton';

import { merchantOnboardingStatusOptions } from '@/entities/merchant';
import { PageTitle } from '@/shared/ui/text/page-title';
import { SettingsColumn } from '@/widgets/settings/settings-column';

import { ManageOnlinePaymentsRow } from './online-payments-page/manage-online-payments-row';
import { StartOnlinePaymentsCard } from './online-payments-page/start-online-payments-card';

export function OnlinePaymentsPage() {
    const { data: status, isError } = useQuery(merchantOnboardingStatusOptions());

    return (
        <SettingsColumn className="space-y-8">
            <PageTitle>Online payments</PageTitle>
            {isError && !status && (
                <p className="text-muted-foreground">Unable to load online payments.</p>
            )}
            {!isError && !status && <Skeleton className="h-96 w-full" />}
            {status === 'NOT_COMPLETED' && <StartOnlinePaymentsCard />}
            {status === 'COMPLETED' && <ManageOnlinePaymentsRow />}
        </SettingsColumn>
    );
}
